'use client';

import { cn } from '@/lib/utils';
import { ChevronLeft, ChevronsLeft } from 'lucide-react';
import { useTranslations } from 'next-intl';
import * as React from 'react';
import { PaginationLink } from '../ui/pagination';

type Props = React.ComponentProps<typeof PaginationLink> & {
    showText?: boolean;
    isSkipIcon?: boolean;
};

const PaginationPrevious = ({
    className,
    showText = true,
    isSkipIcon = false,
    ...props
}: Props) => {
    const transDef = useTranslations('System');

    return (
        <PaginationLink
            aria-label='Go to previous page'
            size='default'
            className={cn(
                'gap-1 pl-2.5',
                {
                    'px-2': !showText,
                },
                className
            )}
            {...props}
        >
            {isSkipIcon ? (
                <ChevronsLeft className='h-4 w-4' strokeWidth={2} />
            ) : (
                <ChevronLeft className='h-4 w-4' strokeWidth={2} />
            )}{' '}
            {showText && <span>{transDef('System_PreviousPage')}</span>}
        </PaginationLink>
    );
};

export default React.memo(PaginationPrevious);
